module.exports = __webpack_public_path__ + "static/4-tips-conten3-a5eb448dc8964ee2abc3b4df5859ab48.png";